import _objectSpread from "C:/Users/amirs/Documents/Projects/top-menu-panel/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from "vuex";
import providerApiService from "../../services/api/ProviderApiService";
import CouponItem from "./CouponItem.vue";
export default {
  name: "CouponsList.vue",
  components: {
    CouponItem: CouponItem
  },
  computed: _objectSpread({}, mapGetters({
    currentProvider: "profile/currentProvider"
  })),
  methods: {
    getCoupons: function getCoupons(page) {
      return providerApiService.getProviderCoupons(this.currentProvider.id, page);
    },
    couponDeleted: function couponDeleted(coupon) {
      this.$refs.unlimitedListRef.deleteItem(coupon);
    },
    createCoupon: function createCoupon(coupon) {
      this.$refs.unlimitedListRef.createItem(coupon);
    }
  }
};